import React, { createContext, useState } from 'react';
import Spinner from '../components/Spinner'; // Your spinner component

export const SpinnerContext = createContext();

export const SpinnerProvider = ({ children }) => {
  const [spinnerText, setSpinnerText] = useState('');
  const [isSpinnerVisible, setIsSpinnerVisible] = useState(false);

  const showSpinner = (text) => {
    setSpinnerText(text);
    setIsSpinnerVisible(true);
  };

  const hideSpinner = () => {
    setSpinnerText('');
    setIsSpinnerVisible(false);
  };

  return (
    <SpinnerContext.Provider value={{ spinnerText, isSpinnerVisible, showSpinner, hideSpinner }}>
      {children}
      {isSpinnerVisible && <Spinner message={spinnerText} hideSpinner={hideSpinner}/>}
    </SpinnerContext.Provider>
  );
};